export default {
  methods: {
    isMobile() {
        return this.$store.state.screen === 'mobile';
    },
    isDesktop() {
        return this.$store.state.screen === 'desktop';
    },
    setCurrentHref(href) {
        sessionStorage.setItem('currentHref', href ?? location.href)
    },
    getCurrentHref() {
      this.currentHref = sessionStorage.getItem('currentHref') ? sessionStorage.getItem('currentHref') : '/'
      return this.currentHref
    },
    removeCurrentHref() {
      sessionStorage.removeItem('currentHref')
    },
    gotoBackURI(backUri) {
      this.removeCurrentHref()
      // location.href = backUri

      if (!backUri) {
        this.$router.push('/')
        return
      }

      try {
        const url = new URL(backUri, window.location.origin)
        if (url.origin === window.location.origin) {
          // 同ドメイン
          const path = url.pathname + url.search + url.hash
          this.$router.push(path)
        } else {
          // 別ドメイン
          location.href = backUri
        }
      } catch (e) {
        // 相対パス
        this.$router.push(backUri)
      }
    }
  }
}